import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'capitalize',
    standalone: false
})
export class CapitalizePipe implements PipeTransform {
    transform(value: unknown): string {
        if (typeof value !== 'string') {
            return '';
        }
        if (value.length === 0) {
            return '';
        }
        return value.charAt(0).toUpperCase() + value.slice(1);
    }
}
